export const SMALL_BUTTON_STYLE = {
  fontSize: "10px",
  height: "28px",
  px: 1,
  letterSpacing: "0.48px",
};
